{
  "version": 1,
  "asset_id": "ca1ff1ba-0868-49f5-9a56-6b262c0385e4",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/ca1ff1ba-0868-49f5-9a56-6b262c0385e4/tiedowns-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/ca1ff1ba-0868-49f5-9a56-6b262c0385e4/tiedowns-thumb.webp",
  "original_filename": "tiedowns-thumb.webp",
  "size": 2800,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:35Z"
}
